module.exports = __webpack_public_path__ + "img/SKMJ_lift9.4999ca4b.jpg";